import { ShareBaseDialog } from 'sharebase/domain';
const template = require('./errorDialog.template');

export class ErrorDialog extends ShareBaseDialog {
	public static $inject = [
		'$mdDialog',
		'$window',
		'gettextCatalog'
	];

	public documentName:string;

	constructor(
		$mdDialog:ng.material.IDialogService,
		private $window:ng.IWindowService,
		gettextCatalog:ng.gettext.gettextCatalog
	) {
		super($mdDialog, template, gettextCatalog.getString('Unable to load your document'));
	}

	public close() {
		this.$window.close();
	}

	public show(documentName:string) {
		this.documentName = documentName;

		super.open();
	}
}


// WEBPACK FOOTER //
// ./src/office-online/components/errorDialog/errorDialog.ts